import React from 'react';
import HeroSection from '../../components/common/HeroSection';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <HeroSection
        title="Terms of Service"
        description="Please read these terms and conditions carefully before using Our Service."
      />
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="prose prose-lg max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-xl shadow-lg">
          {/*
            The `prose prose-lg` classes apply base styling.
            We'll add specific margin and leading utilities with `!` to override prose defaults where needed
            for enhanced spacing and readability.
            "Highlighting" indexed points (h2) is achieved through clear separation and existing prose font styling.
          */}

          <h2 className="!mt-0 !mb-4">1. Agreement to Terms</h2> {/* First heading, no top margin, standard bottom margin */}
          <p className="!mb-6 !leading-relaxed"> {/* Standard paragraph bottom margin and line height */}
            By using our services, you agree to be bound by these Terms of Service. If you disagree with any part of the
            terms, then you may not access the service.
          </p>

          <h2 className="!mt-10 !mb-4">2. Description of Service</h2> {/* Increased top margin for section separation */}
          <p className="!mb-6 !leading-relaxed">
            ASCIIBytes provides IT solutions including web development, mobile app development, cloud solutions, and IT consulting.
            These services are provided "as is" and are subject to change or termination without notice at our sole discretion.
          </p>

          <h2 className="!mt-10 !mb-4">3. User Responsibilities</h2>
          <p className="!mb-3 !leading-relaxed"> {/* Tighter bottom margin before a list */}
            You are responsible for your use of the services and for any content you provide, including compliance with
            applicable laws, rules, and regulations. You should only provide content that you are comfortable sharing with others.
          </p>
          <ul className="!space-y-2 !list-disc !pl-6 !mb-6"> {/* Spacing between list items, explicit disc, padding, and bottom margin */}
            <li className="!leading-relaxed">You agree not to misuse our services or help anyone else to do so.</li>
            <li className="!leading-relaxed">You may not use the services for any illegal or unauthorized purpose.</li>
            <li className="!leading-relaxed">You must not, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).</li>
          </ul>

          <h2 className="!mt-10 !mb-4">4. Intellectual Property</h2>
          <p className="!mb-6 !leading-relaxed">
            The Service and its original content (excluding Content provided by users), features and functionality are and will
            remain the exclusive property of ASCIIBytes and its licensors. The Service is protected by copyright, trademark,
            and other laws of both India and foreign countries. Our trademarks and trade dress may not be used in connection
            with any product or service without the prior written consent of ASCIIBytes.
          </p>

          <h2 className="!mt-10 !mb-4">5. Termination</h2>
          <p className="!mb-6 !leading-relaxed">
            We may terminate or suspend your access to our Service immediately, without prior notice or liability, for any
            reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use
            the Service will immediately cease.
          </p>

          <h2 className="!mt-10 !mb-4">6. Limitation of Liability</h2>
          <p className="!mb-6 !leading-relaxed">
            In no event shall ASCIIBytes, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable
            for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of
            profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or
            inability to access or use the Service; (ii) any conduct or content of any third party on the Service;
            (iii) any content obtained from the Service; and (iv) unauthorized access, use or alteration of your
            transmissions or content, whether based on warranty, contract, tort (including negligence) or any other
            legal theory, whether or not we have been informed of the possibility of such damage, and even if a remedy
            set forth herein is found to have failed of its essential purpose.
          </p>

          <h2 className="!mt-10 !mb-4">7. Governing Law</h2>
          <p className="!mb-6 !leading-relaxed">
            These Terms shall be governed and construed in accordance with the laws of India, without regard to its conflict
            of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver
            of those rights.
          </p>

          <h2 className="!mt-10 !mb-4">8. Changes to Terms</h2>
          <p className="!mb-6 !leading-relaxed">
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is
            material we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes
            a material change will be determined at our sole discretion.
          </p>

          <h2 className="!mt-10 !mb-4">9. Contact Us</h2>
          <p className="!mb-2 !leading-relaxed"> {/* Tighter bottom margin before the address details */}
            If you have any questions about these Terms, please contact us:
          </p>
          <div className="!mb-6 !leading-relaxed"> {/* Wrapper for address details for consistent spacing */}
            ASCIIBytes
            <br />
            <a href="mailto:info@asciibytes.in" className="text-indigo-600 hover:text-indigo-700 transition-colors duration-200">info@asciibytes.in</a> {/* Styled link */}
          </div>
          <p className="text-sm text-gray-500 !mt-10"> {/* Increased top margin for "Last updated" */}
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;